var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "1200px" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline mb-0" },
            [
              _c("v-icon", [_vm._v("edit")]),
              _vm._v(" Modificar permiso\n      "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              staticClass: "p-0",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                { staticClass: "px-4 py-0" },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "p-0",
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h4", { staticClass: "blue--text" }, [
                              _vm._v("\n                Tipo de permiso : "),
                              _c("b", [
                                _vm._v(_vm._s(_vm.permiso.tipo_permiso))
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _vm.id_permi == 44 && _vm.permiso.id_tipo_permiso != 0
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-select", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      items: _vm.tipo_subpermisos,
                                      "item-value": "id",
                                      "item-text": "descripcion",
                                      name: "id_tipo_subpermiso",
                                      label:
                                        "Condición o estado crítico de salud",
                                      autofocus: "",
                                      maxlength: "200",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.obtenerSubpermiso(
                                          _vm.permiso.id_tipo_permiso
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.permiso.id_tipo_subpermiso,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permiso,
                                          "id_tipo_subpermiso",
                                          $$v
                                        )
                                      },
                                      expression: "permiso.id_tipo_subpermiso"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi == 5
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-select", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      items: _vm.capacitacion_censista,
                                      "item-value": function(val) {
                                        return parseInt(val.id)
                                      },
                                      "item-text": "valor",
                                      name: "capacitacion_censista",
                                      label:
                                        "Seleccionar tipo de participación",
                                      autofocus: "",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable:
                                        _vm.permiso.id_permiso ==
                                        (_vm.primer_permiso_censo
                                          ? _vm.primer_permiso_censo.id
                                          : -1),
                                      readonly:
                                        !!_vm.primer_permiso_censo &&
                                        _vm.permiso.id_permiso !=
                                          _vm.primer_permiso_censo.id,
                                      disabled:
                                        !!_vm.primer_permiso_censo &&
                                        _vm.permiso.id_permiso !=
                                          _vm.primer_permiso_censo.id
                                    },
                                    model: {
                                      value: _vm.permiso.id_parametro_permiso,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permiso,
                                          "id_parametro_permiso",
                                          $$v
                                        )
                                      },
                                      expression: "permiso.id_parametro_permiso"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.permiso.id_parametro_permiso && _vm.id_permi == 5
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  !!_vm.primer_permiso_censo &&
                                  _vm.permiso.id_permiso !=
                                    _vm.primer_permiso_censo.id
                                    ? _c(
                                        "v-alert",
                                        {
                                          staticClass: "text-xs-justify",
                                          attrs: {
                                            color: "blue",
                                            icon: "done",
                                            value: "true",
                                            outline: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                "Ya tiene creado el primer permiso de este tipo (Nro de papeleta:\n                  " +
                                                  _vm.primer_permiso_censo
                                                    .numero +
                                                  "\n                  " +
                                                  _vm.primer_permiso_censo
                                                    .fecha_desde +
                                                  "-\n                  " +
                                                  _vm.primer_permiso_censo
                                                    .fecha_hasta +
                                                  "(\n                  " +
                                                  _vm.primer_permiso_censo
                                                    .dias +
                                                  ")dias), en el cual seleccionó la opción: " +
                                                  _vm.capacitacion_censista.filter(
                                                    function(ele) {
                                                      return (
                                                        ele.id ==
                                                        _vm.primer_permiso_censo
                                                          .id_parametro_permiso
                                                      )
                                                    }
                                                  )[0].valor
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.permiso.id_parametro_permiso == 135
                                    ? _c(
                                        "v-alert",
                                        {
                                          staticClass: "text-xs-justify",
                                          attrs: {
                                            color: "indigo",
                                            icon: "warning",
                                            value: "true",
                                            outline: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                Se le otorga una (1) jornada laboral al personal que\n                habiendose capacitado fuera de horario laboral no fué\n                convocado por el INE para el día del empadronamiento D.S. 5097\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.permiso.id_parametro_permiso == 136
                                    ? _c(
                                        "v-alert",
                                        {
                                          staticClass: "text-xs-justify",
                                          attrs: {
                                            color: "indigo",
                                            icon: "warning",
                                            value: "true",
                                            outline: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                Se le otorga dos (2) jornadas laborales al personal que\n                participo efectivamente el día del empadronamiento como\n                agentes censales enel Censo de Población y Vivienda 2024 D.S.\n                5097\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi == 18 && _vm.permiso.id_tipo_permiso != 0
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-select", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      items: _vm.tipo_subpermisos,
                                      "item-value": "descripcion",
                                      "item-text": "descripcion",
                                      name: "tipo_subpermiso",
                                      label:
                                        "Causal de acuerdo al ART. 15 RM 1111:",
                                      autofocus: "",
                                      maxlength: "200",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.obtenerSubpermiso(
                                          _vm.permiso.id_tipo_permiso
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.permiso.motivo,
                                      callback: function($$v) {
                                        _vm.$set(_vm.permiso, "motivo", $$v)
                                      },
                                      expression: "permiso.motivo"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi == 90
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md4: "" } },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      items: _vm.tipos_baja,
                                      "item-value": "descripcion",
                                      "item-text": "descripcion",
                                      label: "Tipo de baja",
                                      maxlength: "50",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.activarBandera()
                                      }
                                    },
                                    model: {
                                      value: _vm.permi_motivo,
                                      callback: function($$v) {
                                        _vm.permi_motivo = $$v
                                      },
                                      expression: "permi_motivo"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi == 87 ||
                          _vm.id_permi == 96 ||
                          _vm.id_permi == 103 ||
                          _vm.id_permi == 105
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-textarea", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      label: "Motivo",
                                      rows: "1",
                                      "auto-grow": "",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.permi_motivo,
                                      callback: function($$v) {
                                        _vm.permi_motivo = $$v
                                      },
                                      expression: "permi_motivo"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi == 101
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md4: "" } },
                                [
                                  _c("v-textarea", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      label: "Motivo",
                                      type: "text",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.permi_motivo,
                                      callback: function($$v) {
                                        _vm.permi_motivo = $$v
                                      },
                                      expression: "permi_motivo"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi == 87 || _vm.id_permi == 103
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      label: "Lugar de comisión ",
                                      maxlength: "50",
                                      rules: _vm.$validate(["required"]),
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.permi_lugar,
                                      callback: function($$v) {
                                        _vm.permi_lugar = $$v
                                      },
                                      expression: "permi_lugar"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi == 12
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha de matrimonio",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerFechaSalidaYEntrada()
                                      }
                                    },
                                    model: {
                                      value: _vm.permiso.fecha_nac_muerte,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permiso,
                                          "fecha_nac_muerte",
                                          $$v
                                        )
                                      },
                                      expression: "permiso.fecha_nac_muerte"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi == 61
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha de nacimiento",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerFechaSalidaYEntrada()
                                      }
                                    },
                                    model: {
                                      value: _vm.permiso.fecha_nac_muerte,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permiso,
                                          "fecha_nac_muerte",
                                          $$v
                                        )
                                      },
                                      expression: "permiso.fecha_nac_muerte"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi == 61
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "time",
                                      label: "Hora de nacimiento",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerFechaSalidaYEntrada()
                                      }
                                    },
                                    model: {
                                      value: _vm.permiso.hora_nac_muerte,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permiso,
                                          "hora_nac_muerte",
                                          $$v
                                        )
                                      },
                                      expression: "permiso.hora_nac_muerte"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi == 6
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha de fallecimiento",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerFechaSalidaYEntrada()
                                      }
                                    },
                                    model: {
                                      value: _vm.permiso.fecha_nac_muerte,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permiso,
                                          "fecha_nac_muerte",
                                          $$v
                                        )
                                      },
                                      expression: "permiso.fecha_nac_muerte"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi == 6
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "time",
                                      label: "Hora de fallecimiento",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerFechaSalidaYEntrada()
                                      }
                                    },
                                    model: {
                                      value: _vm.permiso.hora_nac_muerte,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permiso,
                                          "hora_nac_muerte",
                                          $$v
                                        )
                                      },
                                      expression: "permiso.hora_nac_muerte"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi != 101 &&
                          _vm.id_permi != 100 &&
                          _vm.id_permi != 99 &&
                          _vm.id_permi != 98 &&
                          _vm.id_permi != 89 &&
                          _vm.id_permi != 94 &&
                          _vm.id_permi != 87 &&
                          _vm.id_permi != 88 &&
                          _vm.id_permi != 96 &&
                          _vm.id_permi != 37 &&
                          _vm.id_permi != 38 &&
                          _vm.id_permi != 39 &&
                          _vm.id_permi != 40 &&
                          _vm.id_permi != 41 &&
                          _vm.id_permi != 42 &&
                          _vm.id_permi != 6 &&
                          _vm.id_permi != 61 &&
                          _vm.id_permi != 12 &&
                          _vm.id_permi != 102 &&
                          _vm.id_permi != 43
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha salida",
                                      rules: _vm.$validate(["required"]),
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.calculaDiasHabiles() &&
                                          _vm.desactivarBandera()
                                      },
                                      input: function($event) {
                                        return _vm.obtenerSiguienteFecha()
                                      }
                                    },
                                    model: {
                                      value: _vm.permisoDetalle.fecha_desde,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permisoDetalle,
                                          "fecha_desde",
                                          $$v
                                        )
                                      },
                                      expression: "permisoDetalle.fecha_desde"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi == 102
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha",
                                      rules: _vm.$validate(["required"]),
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.calculaHorarioDiscontinuo()
                                      }
                                    },
                                    model: {
                                      value: _vm.permisoDetalle.fecha_desde,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permisoDetalle,
                                          "fecha_desde",
                                          $$v
                                        )
                                      },
                                      expression: "permisoDetalle.fecha_desde"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi == 101 ||
                          _vm.id_permi == 100 ||
                          _vm.id_permi == 99 ||
                          _vm.id_permi == 98 ||
                          _vm.id_permi == 89 ||
                          _vm.id_permi == 87 ||
                          _vm.id_permi == 88 ||
                          _vm.id_permi == 96 ||
                          (_vm.id_permi >= 37 && _vm.id_permi <= 43)
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.asignarFechaHasta(
                                          _vm.permisoDetalle.fecha_desde
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.permisoDetalle.fecha_desde,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permisoDetalle,
                                          "fecha_desde",
                                          $$v
                                        )
                                      },
                                      expression: "permisoDetalle.fecha_desde"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi == 94
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      items: _vm.tipos_omision,
                                      "item-value": "id",
                                      "item-text": "valor",
                                      label: "Tipo de omisión",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.id_tipo_omision,
                                      callback: function($$v) {
                                        _vm.id_tipo_omision = $$v
                                      },
                                      expression: "id_tipo_omision"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi == 94
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha de omisión de marcado",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.permisoDetalle.fecha_desde,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permisoDetalle,
                                          "fecha_desde",
                                          $$v
                                        )
                                      },
                                      expression: "permisoDetalle.fecha_desde"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          (_vm.id_permi == 6 &&
                            _vm.permiso.fecha_nac_muerte &&
                            _vm.permiso.hora_nac_muerte) ||
                          (_vm.id_permi == 61 &&
                            _vm.permiso.fecha_nac_muerte &&
                            _vm.permiso.hora_nac_muerte) ||
                          (_vm.id_permi == 12 && _vm.permiso.fecha_nac_muerte)
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha salida",
                                      disabled: "",
                                      rules: _vm.$validate(["required"]),
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.permisoDetalle.fecha_desde,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permisoDetalle,
                                          "fecha_desde",
                                          $$v
                                        )
                                      },
                                      expression: "permisoDetalle.fecha_desde"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi == 6 ||
                          _vm.id_permi == 61 ||
                          _vm.id_permi == 12
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha hasta",
                                      disabled: "",
                                      rules: _vm.$validate(["required"]),
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.permisoDetalle.fecha_hasta,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permisoDetalle,
                                          "fecha_hasta",
                                          $$v
                                        )
                                      },
                                      expression: "permisoDetalle.fecha_hasta"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi == 24 ||
                          _vm.id_permi == 18 ||
                          _vm.id_permi == 95 ||
                          _vm.id_permi == 44 ||
                          _vm.id_permi == 103 ||
                          _vm.id_permi == 105
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha hasta",
                                      rules: _vm.$validate(["required"]),
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.calculaDiasHabiles()
                                      }
                                    },
                                    model: {
                                      value: _vm.permisoDetalle.fecha_hasta,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permisoDetalle,
                                          "fecha_hasta",
                                          $$v
                                        )
                                      },
                                      expression: "permisoDetalle.fecha_hasta"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          [90, 5].includes(parseInt(_vm.id_permi)) &&
                          _vm.permisoDetalle.fecha_desde &&
                          _vm.permiso.nro_dias
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha hasta",
                                      disabled: "",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.obtenerSiguienteFecha()
                                      }
                                    },
                                    model: {
                                      value: _vm.permiso.fecha_retorno,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permiso,
                                          "fecha_retorno",
                                          $$v
                                        )
                                      },
                                      expression: "permiso.fecha_retorno"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          [90, 5].includes(parseInt(_vm.id_permi))
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      value: function(val) {
                                        return parseInt(val)
                                      },
                                      name: "dias_incapacidad",
                                      label:
                                        _vm.id_permi == 90
                                          ? "Días de incapacidad"
                                          : _vm.id_permi == 5
                                          ? "Dias a solicitar"
                                          : "",
                                      type: "number",
                                      autofocus: "",
                                      rules: [
                                        function(v) {
                                          return (
                                            v > 0 ||
                                            "Introduzca un valor mayor a 0"
                                          )
                                        }
                                      ],
                                      maxlength: "500",
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.obtenerSiguienteFecha()
                                      },
                                      input: function($event) {
                                        return _vm.obtenerSiguienteFecha()
                                      }
                                    },
                                    model: {
                                      value: _vm.permiso.nro_dias,
                                      callback: function($$v) {
                                        _vm.$set(_vm.permiso, "nro_dias", $$v)
                                      },
                                      expression: "permiso.nro_dias"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi == 18
                            ? _c("v-flex", { attrs: { xs12: "" } }, [
                                _c("p", [
                                  _c("strong", [_vm._v("Total Días:")]),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(this.dias_habiles) +
                                      "\n              "
                                  )
                                ])
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _vm.id_permi != 101 &&
                              _vm.id_permi != 100 &&
                              _vm.id_permi != 99 &&
                              _vm.id_permi != 98 &&
                              _vm.id_permi != 89 &&
                              _vm.id_permi != 12 &&
                              _vm.id_permi != 61 &&
                              _vm.id_permi != 6 &&
                              _vm.id_permi != 90 &&
                              _vm.id_permi != 14 &&
                              _vm.id_permi != 15 &&
                              _vm.id_permi != 17 &&
                              _vm.id_permi != 16 &&
                              _vm.id_permi != 8 &&
                              _vm.id_permi != 18 &&
                              _vm.id_permi != 24 &&
                              _vm.id_permi != 87 &&
                              _vm.id_permi != 88 &&
                              _vm.id_permi != 94 &&
                              _vm.id_permi != 95 &&
                              _vm.id_permi != 37 &&
                              _vm.id_permi != 38 &&
                              _vm.id_permi != 39 &&
                              _vm.id_permi != 40 &&
                              _vm.id_permi != 41 &&
                              _vm.id_permi != 42 &&
                              _vm.id_permi != 43 &&
                              _vm.id_permi != 102 &&
                              _vm.id_permi != 105 &&
                              _vm.id_permi != 44 &&
                              _vm.id_permi != 5
                                ? _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "time",
                                      label: "Hora desde",
                                      rules: _vm.$validate(["required"]),
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.permisoDetalle.hora_desde,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permisoDetalle,
                                          "hora_desde",
                                          $$v
                                        )
                                      },
                                      expression: "permisoDetalle.hora_desde"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.id_permi == 102
                                ? _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "time",
                                      label: "Hora desde",
                                      disabled: "",
                                      rules: _vm.$validate(["required"]),
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.permisoDetalle.hora_desde,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permisoDetalle,
                                          "hora_desde",
                                          $$v
                                        )
                                      },
                                      expression: "permisoDetalle.hora_desde"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.id_permi == 8 ||
                              _vm.id_permi == 87 ||
                              _vm.id_permi == 88
                                ? _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      md2: "",
                                      type: "time",
                                      label: "Hora desde",
                                      rules: _vm.$validate(["required"]),
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.permisoDetalle.hora_desde,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permisoDetalle,
                                          "hora_desde",
                                          $$v
                                        )
                                      },
                                      expression: "permisoDetalle.hora_desde"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _vm.id_permi != 101 &&
                              _vm.id_permi != 100 &&
                              _vm.id_permi != 99 &&
                              _vm.id_permi != 98 &&
                              _vm.id_permi != 89 &&
                              _vm.id_permi != 12 &&
                              _vm.id_permi != 61 &&
                              _vm.id_permi != 6 &&
                              _vm.id_permi != 90 &&
                              _vm.id_permi != 88 &&
                              _vm.id_permi != 14 &&
                              _vm.id_permi != 15 &&
                              _vm.id_permi != 17 &&
                              _vm.id_permi != 16 &&
                              _vm.id_permi != 8 &&
                              _vm.id_permi != 18 &&
                              _vm.id_permi != 89 &&
                              _vm.id_permi != 24 &&
                              _vm.id_permi != 87 &&
                              _vm.id_permi != 94 &&
                              _vm.id_permi != 95 &&
                              _vm.id_permi != 37 &&
                              _vm.id_permi != 38 &&
                              _vm.id_permi != 39 &&
                              _vm.id_permi != 40 &&
                              _vm.id_permi != 41 &&
                              _vm.id_permi != 42 &&
                              _vm.id_permi != 43 &&
                              _vm.id_permi != 102 &&
                              _vm.id_permi != 105 &&
                              _vm.id_permi != 44 &&
                              _vm.id_permi != 5
                                ? _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "time",
                                      label: "Hora hasta",
                                      rules: _vm.$validate(["required"]),
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.permisoDetalle.hora_hasta,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permisoDetalle,
                                          "hora_hasta",
                                          $$v
                                        )
                                      },
                                      expression: "permisoDetalle.hora_hasta"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.id_permi == 102
                                ? _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "time",
                                      label: "Hora hasta",
                                      disabled: "",
                                      rules: _vm.$validate(["required"]),
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.permisoDetalle.hora_hasta,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permisoDetalle,
                                          "hora_hasta",
                                          $$v
                                        )
                                      },
                                      expression: "permisoDetalle.hora_hasta"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.id_permi == 8 ||
                              _vm.id_permi == 87 ||
                              _vm.id_permi == 88
                                ? _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "time",
                                      label: "Hora hasta",
                                      rules: _vm.$validate(["required"]),
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.permisoDetalle.hora_hasta,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.permisoDetalle,
                                          "hora_hasta",
                                          $$v
                                        )
                                      },
                                      expression: "permisoDetalle.hora_hasta"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.id_permi == 102
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-textarea", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      label: "Motivo",
                                      type: "text",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: "",
                                      "auto-grow": "",
                                      rows: "2"
                                    },
                                    model: {
                                      value: _vm.justificacion,
                                      callback: function($$v) {
                                        _vm.justificacion = $$v
                                      },
                                      expression: "justificacion"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi >= 37 && _vm.id_permi <= 43
                            ? _c(
                                "v-flex",
                                [
                                  _c(
                                    "v-radio-group",
                                    {
                                      attrs: { row: "" },
                                      model: {
                                        value: _vm.permiso.rango_horario2,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.permiso,
                                            "rango_horario2",
                                            $$v
                                          )
                                        },
                                        expression: "permiso.rango_horario2"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs6: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: { label: "Mañana", value: 1 }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs6: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: { label: "Tarde", value: 2 }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.id_permi == 96
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-radio-group",
                                    {
                                      attrs: {
                                        row: "",
                                        rules: [
                                          function(v) {
                                            if (v == null) {
                                              return "El campo es obligatorio."
                                            }
                                            return true
                                          }
                                        ]
                                      },
                                      model: {
                                        value: _vm.radio_data,
                                        callback: function($$v) {
                                          _vm.radio_data = $$v
                                        },
                                        expression: "radio_data"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs6: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Con compensación",
                                              value: 1
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs6: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Sin compensación",
                                              value: 0
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            [
                              _vm.id_permi == 12 ||
                              _vm.id_permi == 87 ||
                              _vm.id_permi == 103 ||
                              _vm.id_permi == 95 ||
                              _vm.id_permi == 6 ||
                              _vm.id_permi == 8 ||
                              _vm.id_permi == 61 ||
                              _vm.id_permi == 18 ||
                              _vm.id_permi == 90 ||
                              _vm.id_permi == 5 ||
                              _vm.id_permi == 96 ||
                              (_vm.id_permi >= 37 && _vm.id_permi <= 44)
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "red",
                                        icon: "",
                                        title: "Eliminar archivo"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.eliminarArchivo()
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("clear")])],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-flex", [
                            (_vm.id_permi == 12 ||
                              _vm.id_permi == 8 ||
                              _vm.id_permi == 61 ||
                              _vm.id_permi == 6 ||
                              _vm.id_permi == 87 ||
                              _vm.id_permi == 95 ||
                              _vm.id_permi == 18 ||
                              _vm.id_permi == 103 ||
                              _vm.id_permi == 90 ||
                              _vm.id_permi == 5 ||
                              _vm.id_permi == 96 ||
                              (_vm.id_permi >= 37 && _vm.id_permi <= 44)) &&
                            _vm.ruta_a &&
                            _vm.bandera_file == false
                              ? _c("p", [
                                  _c("strong", [_vm._v("Respaldo: ")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.ruta_a) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            (_vm.id_permi == 12 ||
                              _vm.id_permi == 8 ||
                              _vm.id_permi == 61 ||
                              _vm.id_permi == 6 ||
                              _vm.id_permi == 87 ||
                              _vm.id_permi == 95 ||
                              _vm.id_permi == 18 ||
                              _vm.id_permi == 103 ||
                              _vm.id_permi == 90 ||
                              _vm.id_permi == 5 ||
                              _vm.id_permi == 96 ||
                              (_vm.id_permi >= 37 && _vm.id_permi <= 44)) &&
                            _vm.bandera_file == true
                              ? _c("p", [
                                  _c("strong", [_vm._v("Respaldo: ")]),
                                  _vm._v(
                                    " Sin documento de Respaldo\n              "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("p")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _vm.id_permi == 87 || _vm.id_permi == 96
                            ? _c("v-flex", { attrs: { xs12: "", md4: "" } }, [
                                _c(
                                  "div",
                                  {
                                    class:
                                      this.file == ""
                                        ? "archivo_vacio"
                                        : "archivo_cargado"
                                  },
                                  [
                                    _c("v-icon", [
                                      _vm._v(
                                        _vm._s(
                                          this.file == ""
                                            ? "file_upload"
                                            : "done"
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      ref: "file",
                                      staticClass: "input-file",
                                      attrs: {
                                        type: "file",
                                        color: "primary",
                                        dark: ""
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.handleFileUpload()
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          this.file == "" && _vm.id_permi == 44
                                            ? "Adjuntar informe emitido por la URH y respaldos"
                                            : this.file == "" &&
                                              _vm.id_permi == 6
                                            ? "Adjuntar certificado de defuncion emitido por el registro civil"
                                            : this.file == "" &&
                                              _vm.id_permi >= 37 &&
                                              _vm.id_permi <= 43
                                            ? "Adjuntar formulario otorgado por el servicio médico (Art. 3 Decreto supremo Nº 3164)"
                                            : this.file == "" &&
                                              _vm.id_permi == 12
                                            ? "Adjuntar certificado de matrimonio emitido por el registro civil"
                                            : this.file == "" &&
                                              _vm.id_permi == 61
                                            ? "Adjuntar el certificado de nacimiento emitido por el registro civil"
                                            : this.file == "" &&
                                              _vm.id_permi != 90 &&
                                              _vm.id_permi != 12 &&
                                              _vm.id_permi != 61 &&
                                              _vm.id_permi != 44 &&
                                              _vm.id_permi != 37 &&
                                              _vm.id_permi != 38 &&
                                              _vm.id_permi != 39 &&
                                              _vm.id_permi != 40 &&
                                              _vm.id_permi != 41 &&
                                              _vm.id_permi != 43 &&
                                              _vm.id_permi != 42
                                            ? "Adjuntar respaldo"
                                            : this.file.name
                                        ) +
                                        "\n              "
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.errors.denied
                                  ? _c(
                                      "p",
                                      { staticClass: "red--text body-1" },
                                      [
                                        _vm._v(
                                          "\n                *Formato no admitido por el sistema\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _vm.id_permi == 8 ||
                          _vm.id_permi == 12 ||
                          _vm.id_permi == 6 ||
                          _vm.id_permi == 61 ||
                          _vm.id_permi == 18 ||
                          _vm.id_permi == 90 ||
                          _vm.id_permi == 5 ||
                          _vm.id_permi == 95 ||
                          _vm.id_permi == 103 ||
                          (_vm.id_permi >= 37 && _vm.id_permi <= 44)
                            ? _c("v-flex", { attrs: { md12: "" } }, [
                                _c(
                                  "div",
                                  {
                                    class:
                                      this.file == ""
                                        ? "archivo_vacio"
                                        : "archivo_cargado"
                                  },
                                  [
                                    _c("v-icon", [
                                      _vm._v(
                                        _vm._s(
                                          this.file == ""
                                            ? "file_upload"
                                            : "done"
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      ref: "file",
                                      staticClass: "input-file",
                                      attrs: {
                                        type: "file",
                                        accept: "application/pdf",
                                        rules: _vm.$validate(["required"]),
                                        required: ""
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.handleFileUpload2()
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          this.file == "" && _vm.id_permi == 90
                                            ? "Adjuntar baja médica emitida por el ente gestor de salud"
                                            : this.file == "" &&
                                              _vm.id_permi == 5 &&
                                              _vm.permiso
                                                .id_parametro_permiso == 135
                                            ? "Adjuntar certificado que acredite la capacitación"
                                            : this.file == "" &&
                                              _vm.id_permi == 5 &&
                                              _vm.permiso
                                                .id_parametro_permiso == 136
                                            ? "Adjuntar certificado que acredite la participación activa al CENSO"
                                            : this.file == "" &&
                                              _vm.id_permi == 44
                                            ? "Adjuntar informe emitido por la URH y respaldos"
                                            : this.file == "" &&
                                              _vm.id_permi == 6
                                            ? "Adjuntar certificado de defuncion emitido por el registro civil"
                                            : this.file == "" &&
                                              _vm.id_permi >= 37 &&
                                              _vm.id_permi <= 43
                                            ? "Adjuntar formulario otorgado por el servicio médico (Art. 3 Decreto supremo Nº 3164)"
                                            : this.file == "" &&
                                              _vm.id_permi == 12
                                            ? "Adjuntar certificado de matrimonio emitido por el registro civil"
                                            : this.file == "" &&
                                              _vm.id_permi == 61
                                            ? "Adjuntar el certificado de nacimiento emitido por el registro civil"
                                            : this.file == "" &&
                                              _vm.id_permi == 8
                                            ? "ADJUNTAR JUSTIFICATIVO"
                                            : this.file == "" &&
                                              _vm.id_permi != 90 &&
                                              _vm.id_permi != 12 &&
                                              _vm.id_permi != 61 &&
                                              _vm.id_permi != 44 &&
                                              _vm.id_permi != 37 &&
                                              _vm.id_permi != 38 &&
                                              _vm.id_permi != 39 &&
                                              _vm.id_permi != 40 &&
                                              _vm.id_permi != 41 &&
                                              _vm.id_permi != 43 &&
                                              _vm.id_permi != 42
                                            ? "Adjuntar respaldo"
                                            : this.file.name
                                        ) +
                                        "\n              "
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.errors2.file
                                  ? _c(
                                      "p",
                                      { staticClass: "red--text body-1" },
                                      [
                                        _vm._v(
                                          "\n                *Debe seleccionar un archivo\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.errors2.denied
                                  ? _c(
                                      "p",
                                      { staticClass: "red--text body-1" },
                                      [
                                        _vm._v(
                                          "\n                *Formato no admitido por el sistema\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.id_permi == 94
                        ? _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _vm.id_permi == 94 && _vm.id_tipo_omision == 2
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md6: "" } },
                                    [
                                      _c("v-autocomplete", {
                                        attrs: {
                                          items: _vm.permiso_omision,
                                          "item-value": function(val) {
                                            return val
                                          },
                                          "item-text": function(val) {
                                            return (
                                              val.tipo_permiso +
                                              " : " +
                                              val.fecha_desde +
                                              " , " +
                                              val.hora_desde +
                                              " - " +
                                              val.hora_hasta
                                            )
                                          },
                                          label:
                                            "Seleccionar permiso (omisión de marcado)",
                                          rules: _vm.$validate(["required"]),
                                          required: "",
                                          outline: "",
                                          clearable: ""
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.obtenerHorarioLaboral()
                                          }
                                        },
                                        model: {
                                          value: _vm.permiso.id_permiso_omision,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.permiso,
                                              "id_permiso_omision",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "permiso.id_permiso_omision"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.id_permi == 94 && _vm.id_tipo_omision == 3
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md6: "" } },
                                    [
                                      _c("v-autocomplete", {
                                        attrs: {
                                          items: _vm.compensacion_omision,
                                          "item-value": function(val) {
                                            return val
                                          },
                                          "item-text": function(val) {
                                            return (
                                              val.tipo_permiso +
                                              " : " +
                                              val.fecha_compensacion +
                                              " , " +
                                              val.hora_desde +
                                              " - " +
                                              val.hora_hasta
                                            )
                                          },
                                          label:
                                            "Seleccionar compensación (omisión de marcado)",
                                          rules: _vm.$validate(["required"]),
                                          required: "",
                                          outline: "",
                                          clearable: ""
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.obtenerHorarioLaboral()
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.permiso.id_compensacion_omision,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.permiso,
                                              "id_compensacion_omision",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "permiso.id_compensacion_omision"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.id_permi == 94 && _vm.id_tipo_omision == 4
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md6: "" } },
                                    [
                                      _c("v-autocomplete", {
                                        attrs: {
                                          items:
                                            _vm.compensacion_comisiones_viaje,
                                          "item-value": function(val) {
                                            return val
                                          },
                                          "item-text": function(val) {
                                            return (
                                              val.cite +
                                              " | " +
                                              _vm
                                                .$moment(val.fecha)
                                                .format("DD/MM/YYYY") +
                                              " | " +
                                              val.hora
                                            )
                                          },
                                          label:
                                            "Seleccionar comisión de viaje (omisión de marcado)",
                                          rules: _vm.$validate(["required"]),
                                          required: "",
                                          outline: "",
                                          clearable: ""
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.obtenerHorarioLaboral()
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.permiso.id_compensacion_omision,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.permiso,
                                              "id_compensacion_omision",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "permiso.id_compensacion_omision"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.id_tipo_omision == 1
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md6: "" } },
                                    [
                                      _c(
                                        "v-radio-group",
                                        {
                                          on: {
                                            change: function($event) {
                                              return _vm.obtenerHorarioLaboral()
                                            }
                                          },
                                          model: {
                                            value: _vm.tipo_dia,
                                            callback: function($$v) {
                                              _vm.tipo_dia = $$v
                                            },
                                            expression: "tipo_dia"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            [
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "Mañana",
                                                  value: "1"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            [
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "Tarde",
                                                  value: "2"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.id_tipo_omision == 2
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md6: "" } },
                                    [
                                      _c(
                                        "v-radio-group",
                                        {
                                          on: {
                                            change: function($event) {
                                              return _vm.obtenerHorarioLaboral()
                                            }
                                          },
                                          model: {
                                            value: _vm.tipo_horario,
                                            callback: function($$v) {
                                              _vm.tipo_horario = $$v
                                            },
                                            expression: "tipo_horario"
                                          }
                                        },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Salida",
                                              value: "2"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Retorno",
                                              value: "1"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.id_tipo_omision == 1
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md6: "" } },
                                    [
                                      _c(
                                        "v-radio-group",
                                        {
                                          on: {
                                            change: function($event) {
                                              return _vm.obtenerHorarioLaboral()
                                            }
                                          },
                                          model: {
                                            value: _vm.tipo_horario,
                                            callback: function($$v) {
                                              _vm.tipo_horario = $$v
                                            },
                                            expression: "tipo_horario"
                                          }
                                        },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Ingreso",
                                              value: "1"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Salida",
                                              value: "2"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _vm.id_permi == 14
                            ? _c(
                                "v-flex",
                                [
                                  _c(
                                    "v-radio-group",
                                    {
                                      attrs: { row: "" },
                                      model: {
                                        value: _vm.permiso.rango_horario,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.permiso,
                                            "rango_horario",
                                            $$v
                                          )
                                        },
                                        expression: "permiso.rango_horario"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Todo el día",
                                              value: 0
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Solo mañana",
                                              value: 1
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Solo tarde",
                                              value: 2
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.id_permi == 89 ||
                      _vm.id_permi == 98 ||
                      _vm.id_permi == 99 ||
                      _vm.id_permi == 100 ||
                      _vm.id_permi == 101
                        ? _c(
                            "v-flex",
                            [
                              _c(
                                "v-radio-group",
                                {
                                  attrs: {
                                    row: "",
                                    rules: _vm.$validate(["required"]),
                                    required: ""
                                  },
                                  model: {
                                    value: _vm.permiso.rango_horario,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.permiso,
                                        "rango_horario",
                                        $$v
                                      )
                                    },
                                    expression: "permiso.rango_horario"
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs4: "" } },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          label: "Solo mañana",
                                          value: 1
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs4: "" } },
                                    [
                                      _c("v-radio", {
                                        attrs: { label: "Solo tarde", value: 2 }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _vm.id_permi == 94
                            ? _c(
                                "v-flex",
                                { attrs: { md4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "time",
                                      label: "Hora",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: "",
                                      disabled: ""
                                    },
                                    model: {
                                      value: _vm.hora_calculada,
                                      callback: function($$v) {
                                        _vm.hora_calculada = $$v
                                      },
                                      expression: "hora_calculada"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-layout", [
                        _vm.id_permi == 94
                          ? _c("p", [
                              _c("strong", [_vm._v("Nota.-")]),
                              _vm._v(" "),
                              _c("strong", [
                                _vm._v(
                                  "Se le recomienda tener mayor cuidado y responsabilidad,\n                debido a que su reincidencia sera sancionada de acuerdo al\n                Reglamento Interno de Personal."
                                )
                              ])
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      false
                        ? _c("v-layout", [
                            _vm.id_permi == 8
                              ? _c("p", [
                                  _c("strong", [
                                    _vm._v(
                                      "Usted cuenta con 25 min. de tolerancia antes y\n                despues"
                                    )
                                  ])
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "pr-4" },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n        "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: _vm.loading,
                        disabled: !_vm.valid,
                        color: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("save")]),
                      _vm._v("\n          Registrar\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dac2e74e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dac2e74e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/permiso/dialogs/ModificarPermiso.vue
// module id = null
// module chunks = 